import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

export const setCategoryReducer = (state: State, action: Actions.SetCategory) => {
  state.variableConfiguration.category = action.payload.category;
  const updatedState = assocPath<string, State>(['variableConfiguration', 'category'], action.payload.category, state);
  return updatedState;
};
